
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBannerMsg",
      resolverType: "query",
      routePath: "/getBannerMsg",
      httpMethod: "POST",
    });
  